/* ============================================================
   Tasa Aduanera UE — versión final
   - Se ejecuta UNA SOLA VEZ al pulsar "Añadir al carrito"
   - Añade la tasa junto con el producto en la misma llamada
   - Solo para clientes de la UE (via window.euFeeCountry)
   - Sin polling, sin recargas, sin interferir con nada
   ============================================================ */

(function() {

  const CUSTOMS_FEE_VARIANT_ID = 56841560588614;
  const CUSTOMS_FEE_SKU = 'EU-CUSTOMS-FEE';
  const EU_COUNTRIES = ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK'];

  function esClienteUE() {
    return EU_COUNTRIES.includes(window.euFeeCountry || '');
  }

  async function tasaYaEnCarrito() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return (cart.items || []).some(i => i.sku === CUSTOMS_FEE_SKU);
  }

  async function añadirTasa() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: CUSTOMS_FEE_VARIANT_ID, quantity: 1 })
    });
  }

  async function quitarTasa() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const feeItem = (cart.items || []).find(i => i.sku === CUSTOMS_FEE_SKU);
    if (feeItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: feeItem.key, quantity: 0 })
      });
    }
  }

  document.addEventListener('DOMContentLoaded', async function() {

    // 1. Al cargar la página: sincronizar estado
    if (esClienteUE()) {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const realItems = (cart.items || []).filter(i => i.sku !== CUSTOMS_FEE_SKU);
      const tieneTasa = (cart.items || []).some(i => i.sku === CUSTOMS_FEE_SKU);

      if (realItems.length > 0 && !tieneTasa) {
        await añadirTasa();
      } else if (realItems.length === 0 && tieneTasa) {
        await quitarTasa();
      }
    } else {
      await quitarTasa();
    }

    // 2. Al pulsar "Añadir al carrito": añadir tasa si no existe
    document.addEventListener('submit', async function(e) {
      const form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (!esClienteUE()) return;

      // Esperar a que Dawn procese el añadir al carrito
      setTimeout(async function() {
        const yaEsta = await tasaYaEnCarrito();
        if (!yaEsta) await añadirTasa();
      }, 1000);
    });

  });

})();